import { LeaderboardScreenPlayerInfoConfig } from "../screens/leaderboard/leaderboard_screen_player_info_config.js";
import { ProfileDialog, type ProfileDialogPlayerData } from "./profile_dialog.js";
import { DialogManager } from "./dialog_manager.js";

export class LeaderboardProfileDialog extends ProfileDialog
{
  constructor( player: LeaderboardScreenPlayerInfoConfig )
  {
    super( LeaderboardProfileDialog.toPlayerData( player ) );
  }

  public override name(): string
  {
    return "LeaderboardProfileDialog";
  }

  public static openFor( player: LeaderboardScreenPlayerInfoConfig ): LeaderboardProfileDialog
  {
    return DialogManager.openPooled( "LeaderboardProfileDialog", LeaderboardProfileDialog.toPlayerData( player ), () => new LeaderboardProfileDialog( player ) ) as LeaderboardProfileDialog;
  }

  private static toPlayerData( player: LeaderboardScreenPlayerInfoConfig ): ProfileDialogPlayerData
  {
    return {
      name: player.name,
      avatar_id: player.avatar_id,
      facebook_avatar_url: player.facebook_av_url,
      country_code: player.country_code,
      level: player.level,
      points: player.score,
      user_id: player.user_id,
      days_in_game: player.days_in_game ?? undefined,
      editable: false,
    };
  }
}
